const EmailGreen = ({ size = 48, onClick }) => (
  <svg
    id="EmailGreen"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    onClick={onClick}
  >
    <path
      d="M24.5079 33.1057C20.8567 33.1057 10.8583 19.8369 9.30469 19.0449V10.7665C9.30469 9.63531 10.2215 8.71851 11.3527 8.71851H37.6455C38.7767 8.71851 39.6935 9.63531 39.6935 10.7665V19.0449C36.2263 20.5089 28.1591 33.1057 24.5079 33.1057Z"
      fill="#80D4DC"
    />
    <path
      d="M40.3239 42.8432H8.68388C6.76388 42.8432 5.20068 41.408 5.20068 39.6432V22.2864C5.20068 20.5216 6.76228 19.0864 8.68388 19.0864H9.31268C10.6535 19.0864 11.9303 19.6112 12.8135 20.5264L21.4519 29.4624C21.7543 29.7376 22.0599 30.0736 22.3831 30.4288C23.0039 31.1104 23.9399 32.1376 24.5031 32.1424C25.0663 32.1376 26.0039 31.1088 26.6231 30.4288C26.9463 30.0736 27.2519 29.7376 27.5543 29.4624L36.1911 20.5264C37.0759 19.6112 38.3511 19.0864 39.6919 19.0864H40.3207C42.2407 19.0864 43.8039 20.5216 43.8039 22.2864V39.6432C43.8039 41.408 42.2407 42.8432 40.3207 42.8432H40.3239ZM8.68388 21.0096C7.82148 21.0096 7.12068 21.584 7.12068 22.2896V39.6464C7.12068 40.352 7.82148 40.9264 8.68388 40.9264H40.3223C41.1847 40.9264 41.8855 40.352 41.8855 39.6464V22.2896C41.8855 21.584 41.1847 21.0096 40.3223 21.0096H39.6935C38.8695 21.0096 38.0967 21.3216 37.5719 21.864L28.8903 30.8464L28.8663 30.8688C28.6263 31.0848 28.3431 31.3968 28.0439 31.7264C27.0455 32.8224 25.9159 34.064 24.5079 34.0688H24.4999C23.0919 34.064 21.9623 32.8224 20.9639 31.7264C20.6647 31.3968 20.3815 31.0864 20.1415 30.8688L20.0951 30.8224L11.4359 21.864C10.9111 21.3216 10.1383 21.0096 9.31428 21.0096H8.68548H8.68388Z"
      fill="#5A348C"
    />
    <path
      d="M30.6616 14.544H18.3384C17.8088 14.544 17.3784 14.1136 17.3784 13.584C17.3784 13.0544 17.8088 12.624 18.3384 12.624H30.6616C31.1912 12.624 31.6216 13.0544 31.6216 13.584C31.6216 14.1136 31.1912 14.544 30.6616 14.544Z"
      fill="#5A348C"
    />
    <path
      d="M32.9047 18.8416H16.0967C15.5671 18.8416 15.1367 18.4112 15.1367 17.8816C15.1367 17.352 15.5671 16.9216 16.0967 16.9216H32.9047C33.4343 16.9216 33.8647 17.352 33.8647 17.8816C33.8647 18.4112 33.4343 18.8416 32.9047 18.8416Z"
      fill="#5A348C"
    />
    <path
      d="M30.476 23.1375H18.524C17.9944 23.1375 17.564 22.7071 17.564 22.1775C17.564 21.6479 17.9944 21.2175 18.524 21.2175H30.476C31.0056 21.2175 31.436 21.6479 31.436 22.1775C31.436 22.7071 31.0056 23.1375 30.476 23.1375Z"
      fill="#5A348C"
    />
    <path
      d="M41.7912 42.2368C41.6104 42.2368 41.428 42.1856 41.2648 42.08L26.3736 32.3104C25.9304 32.0192 25.8072 31.424 26.0968 30.9808C26.388 30.5376 26.9832 30.4144 27.4264 30.704L42.3176 40.4736C42.7608 40.7648 42.884 41.36 42.5944 41.8032C42.4104 42.0848 42.1032 42.2368 41.7912 42.2368Z"
      fill="#5A348C"
    />
    <path
      d="M7.20884 42.2368C6.89684 42.2368 6.58964 42.0848 6.40564 41.8032C6.11444 41.36 6.23924 40.7648 6.68244 40.4736L21.5736 30.704C22.0168 30.4128 22.612 30.5376 22.9032 30.9808C23.1944 31.424 23.0696 32.0192 22.6264 32.3104L7.73524 42.08C7.57364 42.1872 7.38964 42.2368 7.20884 42.2368Z"
      fill="#5A348C"
    />
  </svg>
);

export default EmailGreen;
